/**
 * @generated SignedSource<<0d2f457d5fadf1d0a751151b054e41e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShoppingButtons_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_item" | "PdpSharedBuyItNowButton_item">;
  readonly " $fragmentType": "PdpSharedShoppingButtons_item";
};
export type PdpSharedShoppingButtons_item$key = {
  readonly " $data"?: PdpSharedShoppingButtons_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButtons_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShoppingButtons_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyItNowButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAddToCartButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "67f08a79878a01e18caa6567fd3c4545";

export default node;
